import { Box, Typography } from '@mui/material';

export const AppFooter = () => (
  <Box component="footer" sx={{ mt: 5, textAlign: 'center' }}>
    <Typography variant="body2" color="text.secondary">
      Made with ❤️ by Team Platform and Contributors
    </Typography>
  </Box>
);
